import React from 'react';
import * as AppIcons from "component/commonComponents/Icon";
import { DashboardIcon } from "component/commonComponents/Icon";
import * as muiIcon from "@mui/icons-material";
import { StyledIcon } from "./icon.style";

export interface IIcon {
  type: "app" | "mui" | "url";
  value: string;
}

const Icon = (props: IIcon) => {
  const { type, value } = props;

  const renderIcon = (type: string, value: string) => {
    if (!type || !value) {
      return null;
    }
    switch (type) {
      case "app":
        const AppIcon = AppIcons[value];
        return <AppIcon kind="primary" alt="sidebar icon" />;
      case "mui":
        try {
          const MuiIcon = muiIcon[value]
          return (MuiIcon && <MuiIcon />)
        } catch (error) {
          return null;
        }
      case "url":
        return (
          <img src={value} alt="sidebar icon" />
        );
      default:
        return <DashboardIcon kind="secondary" />;
    }
  };

  return (
    <StyledIcon className="icon">
      {renderIcon(type, value)}
    </StyledIcon>
  )
};

export const defaultProps = {
  type: "mui",
  value: "Business",
};

Icon.defaultProps = defaultProps;

export default Icon;